// extracted by mini-css-extract-plugin
module.exports = {"goBack":"GoBack_goBack__18P-J","disabled":"GoBack_disabled__15XhA"};